module.exports = __webpack_public_path__ + "static/media/iphone1.459b1ead.png";